import { IssuesListHeader } from "./components/IssuesListHeader";

export default IssuesListHeader;